/**
 * * Enum de las APIs de la aplicación para comunicación con el BackEnd
 */
export enum CasesStates {
   REOPEN = 0,
   CLOSE = 1,
   REJECTED = 2,
   OPEN = 3
}
